import store from '@state/store'

export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@views/home'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/home',
    name: 'home2',
    redirect: 'home'
  },
  {
    path: '/roles_management/users/',
    name: 'users',
    component: () => import('@views/roles_management/users/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
//  {
//    path: '/roles_management/groups/',
//    name: 'groups',
//    component: () => import('@views/roles_management/groups/index'),
//    meta: {
//      authRequired: true,
//    },
//    props: (route) => ({ user: store.state.auth.currentUser || {} }),
//  },
  {
    path: '/roles_management/perms/',
    name: 'perms',
    component: () => import('@views/roles_management/perms/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/app-sections/',
    name: 'app-sections',
    component: () => import('@views/roles_management/app-sections/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/company-info/',
    name: 'company-info',
    component: () => import('@views/roles_management/company-info/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@views/login-v2'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@views/register-v2'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/confirm-account',
    name: 'confirm-account',
    component: () => import('@views/confirm'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => import('@views/forgetPassword'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { 
          name: 'login', params: routeTo.params ? routeTo.params : {}
        } : { ...routeFrom })
      },
    },
  },
  {
    path: '/scheduled_tasks/periodic_task/',
    name: 'periodic_tasks',
    component: () => import('@views/scheduled_tasks/periodic_tasks/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/scheduled_tasks/task_result/',
    name: 'periodic_tasks_results',
    component: () => import('@views/scheduled_tasks/tasks_results/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/reports/benchmark-config',
    name: 'Máximos',
    component: () => import('@views/retina/reports/config/benchmark'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/reports/consolidated-config',
    name: 'Consolidados',
    component: () => import('@views/retina/reports/config/consolidated'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/reports/config',
    name: 'Configuración de Reportes',
    component: () => import('@views/retina/reports/config'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/reports/warehouses',
    name: 'Reportes por Bodega',
    component: () => import('@views/retina/reports/warehouses'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/reports/locations',
    name: 'Reportes por Ubicación',
    component: () => import('@views/retina/reports/locations'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/reports/own_inventory',
    name: 'Reportes Inventario Propio',
    component: () => import('@views/retina/reports/own_inventory'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  // {
  //   path: '/reports',
  //   name: 'Reportes',
  //   component: () => import('@views/retina/reports'),
  //   meta: {
  //     authRequired: true,
  //   },
  //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
  // },
  {
    path: '/roles_management/groups/',
    name: 'groups',
    component: () => import('@views/retina/groups/index'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/inventory',
    name: 'inventory',
    component: () => import('@views/retina/inventory'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/own_inventory',
    name: 'own_inventory',
    component: () => import('@views/retina/own_inventory'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/warehouse',
    name: 'warehouse',
    component: () => import('@views/retina/warehouse'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/search_qr',
    name: 'search_qr',
    component: () => import('@views/retina/products/search_qr'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/product-expiration-date',
    name: 'product-expiration-date',
    component: () => import('@views/retina/products/check_products'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('@views/retina/products'),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
